/**
 * Date display / DatePicker constants (US policy).
 * Full policy: docs/DATE_POLICY.md
 *
 * Types:
 * - Calendar date: API YYYY-MM-DD → parseDateSafe / toYMD; UI MM/DD/YYYY or Jul 30, 2026
 * - Datetime: API UTC → parseUtcDateTime / formatDateTime (display TZ)
 * - Month period: YYYY-MM → MM/YYYY (not this full-date DatePicker format)
 *
 * Note: in PrimeVue dateFormat, `yy` means a 4-digit year.
 */

/** PrimeVue DatePicker `dateFormat` prop value. */
export const PRIME_DATE_FORMAT_US = 'mm/dd/yy';

/** Human-readable numeric label / docs (not for PrimeVue dateFormat). */
export const DISPLAY_DATE_FORMAT_US = 'MM/DD/YYYY';

/** Placeholder / hint for DatePicker manual input. */
export const DISPLAY_DATE_PLACEHOLDER_US = 'MM/DD/YYYY';

/** Intl options for formatDateShort (MMM D, YYYY). Frozen against accidental mutation. */
export const DISPLAY_DATE_SHORT_US_OPTIONS = Object.freeze({
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});
